async function getAllAvatars(condition) {
  try {
    const resData = await window.axios.get('/api/v1/admin/avatar/all', { params: condition });
    return resData.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
}

async function findAvatarById(id) {
  try {
    const resData = await window.axios.get('/api/v1/admin/avatar', { params: { id } });
    return resData.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
}

async function updateAvatar(params) {
  try {
    const resData = await window.axios.put('/api/v1/admin/avatar', params);
    return resData.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
}

async function uploadAvatarImage(id, imageFile) {
  try {
    const data = new FormData();
    data.append('_id', id);
    data.append('image', imageFile);
    const resData = await window.axios.put('/api/v1/admin/avatar/image', data);
    return resData.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
}

module.exports = { getAllAvatars, findAvatarById, updateAvatar, uploadAvatarImage };
